import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CheckTutorial } from './providers/check-tutorial.service';

// http://localhost:8100/app/tabs/speakers/speaker-details/1

const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'account',
    loadChildren: () => import('./pages/account/account.module').then(m => m.AccountModule)
  },
  {
    path: 'support',
    loadChildren: () => import('./pages/support/support.module').then(m => m.SupportModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'signup',
    loadChildren: () => import('./pages/signup/signup.module').then(m => m.SignUpModule)
  },
  {
    path: 'app',
    loadChildren: () => import('./pages/tabs-page/tabs-page.module').then(m => m.TabsModule)
  },
  {
    path: 'tutorial',
    loadChildren: () => import('./pages/tutorial/tutorial.module').then(m => m.TutorialModule),
    canLoad: [CheckTutorial]
  },
  {
    path: 'clases',
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/clases/clases.module').then( m => m.ClasesPageModule)
      },
      {
        path: 'temas/:clase',
        loadChildren: () => import('./pages/temas/temas.module').then(m => m.TemasPageModule)
      },
      {
        path: 'actividades/:clase',
        loadChildren: () => import('./pages/actividades/actividades.module').then( m => m.ActividadesPageModule)
      },
      {
        path: 'clase/:clase',
        loadChildren: () => import('./pages/clase/clase.module').then( m => m.ClasePageModule)
      }
    ]
  },
  {
    path: 'clase',
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/clase/clase.module').then( m => m.ClasePageModule)
      },
      {
        path: 'temas/:clase',
        loadChildren: () => import('./pages/temas/temas.module').then(m => m.TemasPageModule)
      },
      {
        path: 'tareas/:clase',
        loadChildren: () => import('./pages/tareas/tareas.module').then( m => m.TareasPageModule)
      },
      {
        path: 'actividades/:clase',
        loadChildren: () => import('./pages/actividades/actividades.module').then( m => m.ActividadesPageModule)
      },
      {
        path: 'foros/:foro',
          loadChildren: () => import('./pages/foros/foros.module').then( m => m.ForosPageModule)
      }
    ]
  },
  {
    path: 'tareas',
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/tareas/tareas.module').then( m => m.TareasPageModule)
      },
      {
        path: 'actividad/:actividad/:content_type',
        loadChildren: () => import('./pages/actividad/actividad.module').then( m => m.ActividadPageModule)
      }
    ]

  },
  {
    path: 'temas',
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/temas/temas.module').then( m => m.TemasPageModule)
      },
      {
        path: 'actividad/:actividad/:content_type',
        loadChildren: () => import('./pages/actividad/actividad.module').then( m => m.ActividadPageModule)
      }
    ]

  },
  {
    path: 'actividades',
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/actividades/actividades.module').then( m => m.ActividadesPageModule)
      },
      {
        path: 'actividad/:actividad',
        loadChildren: () => import('./pages/actividad/actividad.module').then( m => m.ActividadPageModule)
      }
    ]
  },
  {
    path: 'actividad',
    loadChildren: () => import('./pages/actividad/actividad.module').then( m => m.ActividadPageModule)
  },
  {
    path: 'directorio',
    loadChildren: () => import('./pages/directorio/directorio.module').then( m => m.DirectorioPageModule)
  },
  {
    path: 'foro',
    loadChildren: () => import('./pages/foro/foro.module').then( m => m.ForoPageModule)
  },
  {
    path: 'entregas',
    loadChildren: () => import('./pages/entregas/entregas.module').then( m => m.EntregasPageModule)
  },
  {
    path: 'tareas',
    loadChildren: () => import('./pages/tareas/tareas.module').then( m => m.TareasPageModule)
  },
  {
    path: 'foros',
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/foros/foros.module').then( m => m.ForosPageModule)
      },
      {
        path: 'foro/:foro',
          loadChildren: () => import('./pages/foro/foro.module').then( m => m.ForoPageModule)
      }
    ]

  },
  {
    path: 'plataforma',
    loadChildren: () => import('./pages/plataforma/plataforma.module').then( m => m.PlataformaPageModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
